import { Spinner } from '@creditornot/cb-progress';
import { Toast } from '@creditornot/cb-toast';
import React from 'react';
import toast, { ToastBar, Toaster as HotToaster } from 'react-hot-toast';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const StyledToast = styled(Toast)`
  width: 400px;
  max-width: 100%;
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  /* adjust react-hot-toast inner message div to look good with cb-toast */
  > div {
    display: block;
    margin: 0;
  }
`;

const StyledSpinner = styled(Spinner)`
  margin-inline-end: 4px;
`;

const mapTypeToVariant = {
  success: 'success' as const,
  error: 'error' as const,
  blank: 'warning' as const,
};

const mapTypeToTitleKey = {
  success: 'toast.success',
  error: 'toast.error',
  blank: 'toast.warning',
};

const Toaster = () => {
  const intl = useIntl();
  return (
    <HotToaster position="top-right">
      {t => (
        <ToastBar toast={t} style={{ background: 'none', boxShadow: 'none', padding: 0, maxWidth: '100%' }}>
          {({ message }) => {
            if (t.type === 'loading') {
              return (
                <StyledToast variant="info" title={intl.formatMessage({ id: 'toast.loading' })}>
                  <MessageContainer>
                    <StyledSpinner size="tiny" />
                    {message}
                  </MessageContainer>
                </StyledToast>
              );
            }
            if (t.type !== 'custom') {
              return (
                <StyledToast
                  variant={mapTypeToVariant[t.type]}
                  title={intl.formatMessage({ id: mapTypeToTitleKey[t.type] })}
                  onCloseButtonClick={() => toast.dismiss(t.id)}
                >
                  <MessageContainer>{message}</MessageContainer>
                </StyledToast>
              );
            }
            return null;
          }}
        </ToastBar>
      )}
    </HotToaster>
  );
};

export default Toaster;
